import gatewayService from '@/modules/common/services/gatewayService';

const BASE_ROUTE = '/v3/ai/business_ai_settings';

const fetchSettings = async (businessUid) => {
  const res = await gatewayService.get(`${BASE_ROUTE}/${businessUid}`);
  return res.data.data.business_ai_settings;
};

/**
 * Partial update - keys left out keep their stored value, so a single toggle does not
 * have to send the whole settings object.
 */
const updateSettings = async (businessUid, settings) => {
  const res = await gatewayService.put(`${BASE_ROUTE}/${businessUid}`, { settings });
  return res.data.data.business_ai_settings;
};

export default {
  fetchSettings,
  updateSettings,
};
